var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.item.classes,domProps:{"innerHTML":_vm._s(_vm.getHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }